<template>
  <div
    style="text-align: left;padding: 20px;"
  >
      <v-row>
        <v-col
          cols="12"
        >
            <v-card elevation="1" style="padding: 0;" class="felx text-center">
                <access-chart :workspaceID="workspaceID" :sources="sources"  style="margin-top: 20px;" />
            </v-card>
        </v-col>
      </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="6"
        v-for="item of ['TOTEM', 'WEBAPP']"
        :key="item"
      >
          <v-card elevation="1" style="padding: 20px 0;">
          <div style="text-align: center;">
            <span style="font-family:Helvetica, Arial, sans-serif;font-size:14px;">
              <b>[{{item}}]</b> Accesos men�
            </span>
          </div>
          <StatsTableV2
            :type="item"
            :workspaceID="workspaceID"
            :sources="sources"
          />
        </v-card>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="6"
      >
      </v-col>
    </v-row>
  </div>
</template>
<script>
import AccessChart from './AccessChart.vue'
import StatsTableV2 from './StatsTableV2.vue'
export default {
  components: {
    AccessChart,
    StatsTableV2,
  },
  props: {
    workspaceID: {
      type: String,
      required: true,
    },
    sources: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
  }),
  computed: {
  },
  watch: {
    workspaceID () {
      this.init()
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
    },
  },
}
</script>
